import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import SpotlightSearch from "./SpotlightSearch";
import { Wrapper, SearchBox, Nav, NavItem, Footer, FooterItem } from "./styles.sideMenu";
import TileIcon from "../../shared/Icon/TileIcon";
import { SUPPORT_EMAIL } from "../../../utils/constants/support";
import useVendorStore from "../HomePage/useVendorStore";
import { HOME_SECTION_TYPES } from "../HomePage/constants";
import { handleActionType } from "../../../helpers/app_router";

const HELP_ICON_SRC = "/logos/help-circle.svg";
const SEARCH_ICON_SRC = "/logos/search-basic.svg";

export default function SideMenu({ orderTiles = [], setFailedIconIds }) {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const navigate = useNavigate();

  const homePageSections = useVendorStore((state) => state.homePageSections);

  const navItems = useMemo(() => {
    const sections = homePageSections || [];
    const iconGridItems = sections
      .filter((section) => section?.type === HOME_SECTION_TYPES.iconGrid)
      .flatMap((section) => section?.items || [])
      .sort((a, b) => (a?.display_order || 0) - (b?.display_order || 0));

    return iconGridItems
      .filter((item) => item?.action_type)
      .map((item) => ({
        key: item.id,
        label: item.title,
        icon: item.icon_url,
        actionType: item.action_type,
        actionData: item.action_data || {},
      }));
  }, [homePageSections]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "k" && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        setIsSearchOpen(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <Wrapper>
      <SearchBox onClick={() => setIsSearchOpen(true)}>
        <img src={SEARCH_ICON_SRC} alt="" />
        <input placeholder="Search..." readOnly />
      </SearchBox>
      <Nav>
        {orderTiles.map((tile) => (
          <NavItem
            key={tile.id || tile.iconKey}
            onClick={tile.onClick}
            disabled={tile.disabled}
          >
            <TileIcon
              src={tile.icon}
              onError={() => setFailedIconIds((prev) => ({ ...prev, [tile.iconKey]: true }))}
            >
              {tile.badge}
            </TileIcon>
            <span>{tile.label}</span>
          </NavItem>
        ))}
      </Nav>
      <Footer>
        <FooterItem onClick={() => { window.location.href = `mailto:${SUPPORT_EMAIL}`; }}>
          <img src={HELP_ICON_SRC} alt="" />
          <span>Get help</span>
        </FooterItem>
      </Footer>
      <SpotlightSearch
        items={navItems}
        open={isSearchOpen}
        onClose={() => setIsSearchOpen(false)}
        onSelect={(item) => handleActionType(item.actionType, item.actionData, navigate)}
      />
    </Wrapper>
  );
}
